import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheck,
  faClose,
  faEye,
  faHome,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { useApi } from "../helpers/useApi";
import OffCanvas from "../components/OffCanvas";
import { Accordion } from "react-bootstrap";
import { SelectBox } from "../components/SelectBox";
import { Textbox } from "../components/Textbox";

export const TruckKYC = () => {
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const callApi = useApi();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [selectedData, setSelectedData] = useState({});
  const [isApproved, setIsApproved] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (isTyping) {
        setIsTyping(false);
        getData(1);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handlePageChange = (newPage) => {
    getData(newPage);
  };

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `orderBy=lastUpdate`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.KYC + `/truck?${queryParams}`
      );
      if (response.status) {
        var ddata = response.data;
        setData(ddata);
        if(selectedData){
          const sd = ddata?.items.find((item) => item.id === selectedData.id);
          if (sd) {
            setSelectedData(sd);
            setShowDetail(true);
          } else {
            setShowDetail(false)
          }
        }
      }
    } catch(ex) {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  };

  const handleView = (id) => {
    const sd = data.items.find((item) => item.id === id);
    if (sd) {
      // console.log("Selected:", selectedData);
      setSelectedData(sd);
      setShowDetail(true);
    } else {
      // console.warn("No data found for ID:", id);
      sendError("No data found");
    }
  };

  const RejectKYC = async ()=>{
      const payload = {
        "rejectionReason": rejectReason,
      }
    await onSubmit(payload);
  }

  const onSubmit = async (data) => {
    try {
      const payload = {
        "id": selectedData.id,
        "status": isApproved ? "Approved" : "Rejected",
        "rejectionReason": data?.rejectionReason || null,
        "regDate": data?.regDate || null,
        "regValidityDate": data?.regValidity || null,
        "ownerName": data?.owner || null,
        "ownership": data?.ownership || null,
        "chassisNumber": data?.chassisNumber || null,
        "engineNumber": data?.engineNumber || null
      }
      const response = await callApi(`${API_URL_ENDPOINT.KYC}/truck`, {
        method: "PUT",
        data: payload,
      });
      if (response.status) {
        setIsApproved(null)
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  return (
    <>
      <OffCanvas
        show={showDetail}
        placement="end"
        handleClose={() => setShowDetail(false)}
        width="60%"
        title="KYC Verification"
      >
        <div className="py-0">
          <div className="mb-2 d-flex justify-content-between align-item-center">
            <div>
              <strong>Reg No.:</strong>{" "}
              <span>{selectedData?.regNumber || "-"}</span>
            </div>
            <div>{status(selectedData.status)}</div>
          </div>
          <hr />
          <div className="col-12">
            <div className="">
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-center m-0">Vehicle RC</p>
                <p
                  style={{ fontSize: 12 }}
                  className="text-center text-dark m-0"
                >
                  {selectedData.updatedAt}
                </p>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="m-0 fw-bold">Front Side</p>
                  <img
                    src={selectedData.frontDocumentPath}
                    alt={"Truck RC Front Side"}
                    className="img-fluid rounded w-100"
                    style={{ maxHeight: "200px" }}
                  />
                </div>
                <div className="col-md-6">
                  <p className="m-0 fw-bold">Back Side</p>
                  <img
                    src={selectedData.backDocumentPath}
                    alt={"Truck RC Front Side"}
                    className="img-fluid rounded w-100"
                    style={{ maxHeight: "200px" }}
                  />
                </div>
              </div>

              {selectedData.rejectionReason && (
                <div className="border-danger border rounded-2 px-2 mt-3">
                  <p className="text-danger m-0 fw-bold">Rejection Reason</p>
                  <p className="text-danger m-0" style={{ fontSize: 12 }}>
                    {selectedData.rejectionReason}
                  </p>
                </div>
              )}

              {isApproved == null && selectedData.status == "InProgress" && (
                <div className="mt-3 d-flex align-items-center justify-content-start  gap-2">
                  <button
                    className="btn btn-success"
                    onClick={() => setIsApproved(true)}
                  >
                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                    Approve
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => setIsApproved(false)}
                  >
                    <FontAwesomeIcon icon={faBan} className="me-1" />
                    Reject
                  </button>
                </div>
              )}

              {/* Show Reject Reason Input if this doc is being rejected */}
              {isApproved === false && (
                <div className="mt-2">
                  <textarea
                    className="form-control shadow-none"
                    rows="2"
                    placeholder="Enter reject reason"
                    value={rejectReason || ""}
                    onChange={(e) => setRejectReason(e.target.value)}
                  />
                  <button
                    className="btn btn-success mt-2"
                    onClick={() => RejectKYC()}
                  >
                    Submit Reason
                  </button>
                  <button
                    className="btn btn-danger mt-2 ms-1"
                    onClick={() => setIsApproved(null)}
                  >
                    Cancel
                  </button>
                </div>
              )}
              {isApproved === true && (
                <FormProvider {...methods}>
                  <Form onSubmit={handleSubmit(onSubmit)} className="mt-4">
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Textbox
                            Label="Reg Date"
                            name={"regDate"}
                            Type="date"
                            Placeholder="Enter Reg. Date"
                            validationRules={{ required: "Date is required" }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Textbox
                            Label="Reg Validity"
                            name={"regValidity"}
                            Type="date"
                            Placeholder="Enter Reg. Validity Date"
                            validationRules=""
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Textbox
                            Label="Owner Name"
                            name={"owner"}
                            Placeholder="Enter Owner Name"
                            validationRules={{ required: "Name is required" }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Textbox
                            Label="Chassis Number"
                            name={"chassisNumber"}
                            Placeholder="Enter Chassis Number"
                            validationRules={{ required: "Required" }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Textbox
                            Label="Engine Number"
                            name={"engineNumber"}
                            Placeholder="Enter Engine Number"
                            validationRules={{ required: "Required" }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <SelectBox
                            Label="Ownership"
                            name={"ownership"}
                            validationRules={{
                              required: "Ownership is required",
                            }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          >
                            <option value={""}>Select Ownership</option>
                            <option value={"Individual"}>Individual/Private</option>
                            <option value={"Business"}>Company/Business</option>
                          </SelectBox>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="text-start">
                      <Button
                        type="submit"
                        disabled={isSubmitting}
                        variant="success"
                      >
                        Approve
                      </Button>
                      <Button
                        type="button"
                        className="ms-2"
                        onClick={()=>setIsApproved(false)}
                        disabled={isSubmitting}
                        variant="danger"
                      >
                        Reject
                      </Button>
                    </div>
                  </Form>
                </FormProvider>
              )}
            </div>
          </div>
        </div>
      </OffCanvas>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Truck KYC Requests</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Truck KYC Requests</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Form.Control
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsTyping(true);
            }}
            type="text"
            className="shadow-none"
            placeholder={"Search..."}
          />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
            </div>
          ) : (
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Vehicle Number</th>
                  <th className="border-0 text-center">Owner Name</th>
                  <th className="border-0 text-center">Reg Date</th>
                  <th className="border-0 text-center">Truck Type</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.regNumber || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.ownerName || "-"}
                      </td>
                      <td className="fw-bold align-middle text-cemter">
                        {item.regDate || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.truckTypes?.name || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {status(item.status)}
                      </td>
                      <td className="text-end align-middle">
                        <Button
                          variant="primary"
                          className="btn-sm"
                          onClick={() => handleView(item.id)}
                        >
                          <FontAwesomeIcon icon={faEye} className="me-1" /> View
                        </Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination
              totalPages={data.totalPage}
              loading={dataLoading}
              onPageChange={handlePageChange}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
